import { getAssetsCdnUrlFromEnv } from "@/lib/env";

const ABSOLUTE_URL_PATTERN = /^(https?:|blob:|data:|\/)/;

export function getAssetUrl(key: string): string {
  if (!key) {
    return "";
  }

  if (ABSOLUTE_URL_PATTERN.test(key)) {
    return key;
  }

  const cdnBaseUrl = getAssetsCdnUrlFromEnv();

  if (!cdnBaseUrl) {
    return key.startsWith("/") ? key : `/${key}`;
  }

  const normalizedKey = key.replace(/^\/+/, "");

  return `${cdnBaseUrl.replace(/\/+$/, "")}/${normalizedKey}`;
}
